import React from 'react';
import './PetAnimations.css';

export default function PolarBearSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F0EDE5';
  const lightColor = color ? lighten(color) : '#FAFAF7';
  const darkColor = color ? darken(color) : '#D4CFC4';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <circle cx="90" cy="70" r="5" fill={darkColor} />
      {/* Body */}
      <ellipse cx="60" cy="72" rx="32" ry="26" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="78" rx="20" ry="16" fill={lightColor} />
      {/* Back legs */}
      <rect x="32" y="88" width="14" height="16" rx="6" fill={bodyColor} />
      <rect x="74" y="88" width="14" height="16" rx="6" fill={bodyColor} />
      {/* Front legs */}
      <rect x="40" y="90" width="12" height="14" rx="5" fill={darkColor} />
      <rect x="68" y="90" width="12" height="14" rx="5" fill={darkColor} />
      {/* Paw pads */}
      <ellipse cx="46" cy="104" rx="6" ry="3" fill={darkColor} />
      <ellipse cx="74" cy="104" rx="6" ry="3" fill={darkColor} />
      <ellipse cx="39" cy="104" rx="7" ry="3" fill={darkColor} />
      <ellipse cx="81" cy="104" rx="7" ry="3" fill={darkColor} />
      {/* Head */}
      <ellipse cx="60" cy="40" rx="24" ry="22" fill={bodyColor} />
      {/* Muzzle */}
      <ellipse cx="60" cy="48" rx="12" ry="9" fill={lightColor} />
      {/* Ears */}
      <circle cx="40" cy="22" r="7" fill={bodyColor} />
      <circle cx="80" cy="22" r="7" fill={bodyColor} />
      <circle cx="40" cy="22" r="4" fill={darkColor} />
      <circle cx="80" cy="22" r="4" fill={darkColor} />
      {/* Eyes */}
      <ellipse cx="50" cy="38" rx="3.5" ry="4" fill="white" />
      <ellipse cx="70" cy="38" rx="3.5" ry="4" fill="white" />
      <ellipse cx="51" cy="38" rx="2" ry="2.5" fill="#1A1A1A" />
      <ellipse cx="71" cy="38" rx="2" ry="2.5" fill="#1A1A1A" />
      <circle cx="52" cy="37" r="0.8" fill="white" />
      <circle cx="72" cy="37" r="0.8" fill="white" />
      {/* Nose */}
      <ellipse cx="60" cy="46" rx="4" ry="3" fill="#1A1A1A" />
      <ellipse cx="60" cy="45.5" rx="1.5" ry="1" fill="#3A3A3A" />
      {/* Mouth */}
      <path d="M60 49C60 49 57 52 55 52" stroke="#8A8078" strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <path d="M60 49C60 49 63 52 65 52" stroke="#8A8078" strokeWidth="0.8" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
